const HelpPage = () => (
  <div className="p-8 text-center">
    <h2 className="text-3xl font-bold mb-4">Help & Support</h2>
    <p className="text-gray-600">Find FAQs and contact support here.</p>
  </div>
);

export default HelpPage;